import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Ganancias from "./pages/Ganancias";
import Tablas from "./pages/Tablas";
import Registrar from "./pages/Registrar";
import Logout from "./pages/Logout";
import Lideres from "./pages/Lideres";
import DetalleLider from "./pages/DetalleLider";
import NotFound from "./pages/NotFound";
import PublicLayout from "./components/PublicLayout";
import PrivateRoute from "./components/PrivateRoute";
import "./App.css";

function App() {

  return (
    <Router>
      <Routes>
        {/* Rutas públicas */}
        <Route element={<PublicLayout />}>
          <Route index element={<Login />} />
        </Route>

        {/* Rutas ptivadas */}
        <Route element={<PrivateRoute> 
          {(usuario) => (<Layout usuario={usuario} />)} 
          </PrivateRoute>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/registrar" element={<Registrar />} />
          <Route path="/ganancias" element={<Ganancias />} />
          <Route path="/tablas" element={<Tablas />} />
          <Route path="/lideres" element={<Lideres />} />
          <Route path="/lideres/:nombre" element={<DetalleLider />} />
          <Route path="/logout" element={<Logout />} />
        </Route>

        {/* Ruta 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
